type StepItem = {
    highlight: string
    text: string
    highlightClass?: string
    textClass?: string
}

type Props = {
    icon: string
    title: string
    step: StepItem[]
    className?: string      
    textAlign?: "left" | "center" | "right"
}
    
    const StepsCard = ({ icon, title, step, className="", textAlign = "center" }: Props) => {
        return (
        <div className={`step-card content-two-card ${className}`}>
            <img src={icon} alt={title} className='step-icon' />
            <h3>{title}</h3>
            <div className={`step-container content-two-text text-${textAlign}`}>
            {step.map((b, i) => (
                <div key={i} className="step-item content-two-item">
                <span className={`step-text ${b.highlightClass ?? ''}`}>{b.highlight}</span>
                <span className={`step-subtext ${b.textClass ?? ''}`}>{b.text}</span>
                </div>
            ))}
            </div>
        </div>
        )
    }

export default StepsCard
